import PropTypes from 'prop-types';
import { Carousel } from '@bwoty-web/ui-kit';

import { getMonthName } from '../../utils/date';
import WeatherChartMonth from './weatherChartMonth';

import './weatherChart.scss';

const WeatherChart = ({
  climate,
  siteId,
  currentMonth,
  texts,
  hideExplanation,
  tightNavPosition,
}) => {
  let { temperature, sunshineHours, rainfreeDays } = climate;
  if (!temperature) {
    temperature = {};
  }
  if (!temperature.day) {
    temperature.day = [];
  }
  if (!temperature.night) {
    temperature.night = [];
  }
  if (!temperature.water) {
    temperature.water = [];
  }
  if (!sunshineHours) {
    sunshineHours = [];
  }
  if (!rainfreeDays) {
    rainfreeDays = [];
  }

  const weatherMonths = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

  return (
    <div>
      <Carousel
        itemSize={3}
        itemSizeTablet={4}
        itemSizeMobile={3}
        tightNavPosition={tightNavPosition}
      >
        {weatherMonths.map((i) => {
          return (
            <WeatherChartMonth
              key={i}
              month={getMonthName(i, siteId)}
              day={temperature?.day[i]}
              night={temperature?.night[i]}
              waterTemp={temperature?.water[i]}
              sunshineHoursPerDay={sunshineHours[i]}
              rainFreeDays={rainfreeDays[i]}
              active={currentMonth === i}
              texts={texts}
            />
          );
        })}
      </Carousel>
      {!hideExplanation && (
        <p className="gw-weather-chart__explanation">{texts.explanationText}</p>
      )}
    </div>
  );
};

WeatherChart.propTypes = {
  climate: PropTypes.shape({
    sunshineHours: PropTypes.arrayOf(PropTypes.number),
    temperature: PropTypes.shape({
      day: PropTypes.arrayOf(PropTypes.number),
      night: PropTypes.arrayOf(PropTypes.number),
      water: PropTypes.arrayOf(PropTypes.number),
    }),
    rainfreeDays: PropTypes.arrayOf(PropTypes.number),
  }),
  siteId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currentMonth: PropTypes.number,
  texts: PropTypes.shape({
    waterTempText: PropTypes.string,
    sunHoursPerDayText: PropTypes.string,
    rainFreeDaysText: PropTypes.string,
    explanationText: PropTypes.string,
  }).isRequired,
  hideExplanation: PropTypes.bool,
  tightNavPosition: PropTypes.bool,
};

WeatherChart.defaultProps = {
  siteId: 1,
  currentMonth: 0,
  climate: {},
  hideExplanation: false,
  tightNavPosition: false,
};

export default WeatherChart;
